/**
 * Whether the SMS button is offered next to the WhatsApp one.
 *
 * Every link travels through WhatsApp for now. The channel is still supported end to end — the use
 * case, the repository and the waiting screen all handle `SMS` — so turning it back on is this flag
 * and nothing else.
 */
export const IS_SMS_CHANNEL_ENABLED: boolean = false;
